export const MUNICIPAL_PROPERTY_CATALOG_PATH = "catalog";
